const actions = {
  INITIALIZING: 'INITIALIZING',
  INITIALIZED: 'INITIALIZED',
  ACQUIRED_ID_TOKEN_SUCCESS: 'ACQUIRED_ID_TOKEN_SUCCESS',
  ACQUIRED_ACCESS_TOKEN_SUCCESS: 'ACQUIRED_ACCESS_TOKEN_SUCCESS',
  ACQUIRED_ACCESS_TOKEN_ERROR: 'ACQUIRED_ACCESS_TOKEN_ERROR',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  ACQUIRED_ID_TOKEN_ERROR: 'ACQUIRED_ID_TOKEN_ERROR',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  AUTHENTICATED_STATE_CHANGED: 'AUTHENTICATED_STATE_CHANGED',
};

export const AuthenticationState = {
  Unauthenticated: 'Unauthenticated',
  InProgress: 'InProgress',
  Authenticated: 'Authenticated',
};

export default actions;
